import { render, staticRenderFns } from "./PortForm.vue?vue&type=template&id=39473ada"
import script from "./PortForm.vue?vue&type=script&lang=js"
export * from "./PortForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports